import Vue from 'vue'
import { format } from 'date-fns'

export default {
  REMOVE (state, index) {
    // ({ index })
    // Shallow copy + reference swap: broad invalidation without deep-cloning the store.
    const all = { ...state.all }
    delete all[index]
    state.all = all
  },
  FLUSH_ACTIVE (state) {
    state.active = false
  },
  UPDATE_BOUND (state, { key, value }) {
    state.bound[key] = value
  },
  UPDATE (state, resource) {
    const index = state.all[resource.id]
    if (index === -1) {
      Vue.set(state.all, resource.id, Object.freeze({ ...resource }))
    } else {
      const temp = Object.freeze({ ...state.all[resource.id], ...resource })
      Vue.set(state.all, resource.id, temp)
    }
  },
  MERGE (state, resource) {
    // Shallow top-level copy keeps the reference-swap trickle-down (all dependent
    // getters recompute) while only allocating new objects for changed records.
    // Records are frozen: the reference swap is the change signal, so per-record
    // Vue reactivity is pure overhead (observation walk over every entity).
    const newState = { ...state.all }
    for (const r in resource) {
      // Get existing object from state, or create an empty object based on a stub
      const oldObj = state.all[r] || Object.assign({}, state.stub)
      // Merge the new data into the old object.
      const newObj = Object.freeze(Object.assign({}, oldObj, resource[r]))
      newState[r] = newObj
    }
    state.all = newState
  },
  REPLACE_ALL (state, resource) {
    for (const key in resource) {
      const record = resource[key]
      if (record && typeof record === 'object' && !Object.isFrozen(record)) {
        Object.freeze(record)
      }
    }
    state.all = resource
  },
  SET_DYNAMIC (state, resource) {
    state[resource.key] = resource.value
  },
  updateBound (state, payload) {
    state.bound = payload
  },
  replaceFilter (state, data) {
    Vue.set(state, 'filter', data)
  },
  updateFilter (state, { key, value }) {
    const index = state.filter[key]
    if (index === -1) {
      Vue.set(state.filter, key, value)
    } else {
      const temp = { ...state.filter[key], ...value }
      Vue.set(state.filter, key, temp)
    }
  },
  SET_PRINT_PATH (state, path) {
    state.print_path = path
  },
  SET_FETCH_DATE (state, date) {
    state.latest_fetch = format(new Date(), 'YYYY-MM-DD HH:mm:ss')
  },

  updated (state) {
    state.isStale = false
  },

  isStale (state) {
    state.isStale = true
  }
}
